module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"panel":"Control Panel","speed":"Network Speed Test"},"ru":{"panel":"Панель управления","speed":"Проверка скорости сети"}}')
  delete Component.options._Ctor
}
